export default "__VITE_ASSET__CTcvaTNj__"